module.exports = __webpack_public_path__ + "img/MINUS.788fe461.svg";